import { render, staticRenderFns } from "./TestDataStatistc.vue?vue&type=template&id=3fda72c6"
import script from "./TestDataStatistc.vue?vue&type=script&lang=js"
export * from "./TestDataStatistc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports